<template>

    <div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">{{ lang.get("planning.nav.planning") }}</h2>
                <div class="box-tools">
                    <button
                        class="btn btn-default btn-sm"
                        type="button"
                        v-tooltip="'Volledig scherm'"
                        @click="expandGantt()"
                    >
                            <i class="mdi mdi-arrow-expand"></i>
                    </button>
                    <button
                        class="btn btn-default btn-sm"
                        type="button"
                        v-tooltip="'Exporteren naar PDF'"
                        @click="exportToPdf()"
                    >
                        <i class="mdi mdi-file-pdf-box"></i>
                    </button>
                </div>
            </div>
            <div class="box-body">
                <div class="row" v-if="loaded">
                    <div class="col-sm-2 table-officeusers" v-show="showusers" :style="{height: getHeight + 'px'}">
                        <div v-if="project == ''">
                            <label for="TeamFilter">Team filter:</label>
                            <v-select
                                id="TeamFilter"
                                v-if="teams.loaded"
                                v-model="teams.selected.value"
                                :options="teams.selectData"
                                :reduce="entry => entry.value"
                                @input="updateTeamSelected"
                            ></v-select>
                            <i v-else class="fa fa-refresh fa-spin"></i>
                        </div>
                        <div class="mt-4 btn-group btn-group-xs">
                            <button class="btn btn-default" type="button" @click="subWeek()"><i class="fa fa-chevron-left"></i></button>
                            <button class="btn btn-default" type="button">{{ currentWeekNr }}</button>
                            <button class="btn btn-default" type="button" @click="addWeek()"><i class="fa fa-chevron-right"></i></button>
                        </div>
                        <table class="table table-striped" v-if="getOfficeUsers.length">
                            <thead>
                            <tr>
                                <th colspan="2">{{ lang.get("global.name") }}</th>
                                <th>
                                    <input type="checkbox" @change="toggleCheckedUserAll"/>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="user in getOfficeUsers">
                                <td>
                                    <label :for="'user-' + user.uuid">{{ user.fullname }}</label>
                                </td>
                                <td>
                                    {{ getAvailability(user.uuid) }}
                                </td>
                                <td>
                                    <input
                                        type="checkbox"
                                        :value="user.uuid"
                                        :id="'user-' + user.uuid"
                                        :checked="checkedUsers.includes(user.uuid)"
                                        @change="toggleCheckedUser(user)"
                                    >
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div :class="{'col-sm-10':showusers,'col-sm-12':!showusers}">
                        <button class="btn btn-xs btn-default" type="button" v-if="!showusers" @click="showusers = true"><i class="fa fa-chevron-right"></i></button>
                        <gantt-planning
                            :half-days="halfDays"
                            :tasks="tasks"
                            :range="range"
                            :plannedstate="plannedstate"
                            :show-budget="shouldShowBudget"
                            :show-buttons="shouldShowButtons"
                            :special-project-uuid="specialProjectUuid"
                            @task-clicked="onTaskClick"
                            @planned-item-clicked="onPlannedItemClick"
                        ></gantt-planning>
                    </div>
                </div>
            </div>
            <div class="overlay" v-show="!loaded">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <div class="modal fade" id="searchOfficeModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Collega toevoegen</h4>
                    </div>
                    <div class="modal-body no-padding">
                        <table class="table table-striped" v-if="getOfficeUsers.length > 0">
                            <thead>
                                <tr>
                                    <th>{{ lang.get("global.name") }}</th>
                                    <th>{{ lang.get("planning.availability") }}</th>
                                    <th class="col-sm-2">{{ lang.get("global.select") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in officeUsersForTask">
                                    <td>{{ user.fullname }}</td>
                                    <td>{{ getAvailability(user.uuid) }}</td>
                                    <td>
                                        <button @click="onOfficeUserSelect(user)" class="btn btn-primary btn-xs">{{ lang.get("global.select") }}</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';
    import GanttPlanning from '../Gantt/Planning';
    import axios from 'axios';
    import moment from 'moment';
    import Lang from '../../Lang';
    import Hub from "../../Hub";
    import vSelect from "vue-select";

    export default {

        components: {
            GanttPlanning,
            vSelect,
        },

        computed:{
            ...mapGetters([
                "getOfficeUsers",
                "getRoutes",
                'getAuth',
            ]),

            currentWeekNr(){
                return this.weeknr.format("ww");
            },

            halfDays() {
                return Boolean(this.getAuth.settings.archibase.settings.planning_half_days);
            },

            shouldShowBudget() {
                return this.showBudget === true ||
                    this.showBudget === 'true';
            },

            shouldShowButtons() {
                return this.showButtons === true ||
                    this.showButtons === 'true';
            },

            officeUsersForTask() {
                let users = this.getFilteredOfficeUsers();

                if (this.tasks.usersAlreadyAssigned.length) {
                    // If a user is already assigned to this task do not show it again.
                    users = users.filter((user) => {
                      return !this.tasks.usersAlreadyAssigned.includes(user.uuid);
                   });
                }

                return users;
            },

            getHeight() {
                return window.innerHeight - 200;
            }
        },

        data() {
            return {
                addfortask:'',
                availability:{},
                checkedUsers: [],
                checkedUsersProjects: [],
                detachuser:null,
                lang:Lang,
                lastaction:{
                    taskmodel_id:null,
                    user_id:null,
                    date:null,
                    part:null,
                },
                loaded:false,
                plannedstate:{},
                plannedUsers: [],
                range:[],
                showusers:true,
                specialProjectUuid: null,
                tasks: {
                    data: [],
                    usersAlreadyAssigned: [],
                },
                teams: {
                    loaded:false,
                    planningData: [],
                    selectData: [],
                    selected: {
                        projectUuids:null,
                        userUuids:null,
                        value:null,
                    },
                },
                weeknr:null,
            }
        },

        methods:{
            ...mapActions([
                "parseData",
            ]),

            addPlannedState(user_id, formatteddate, taskmodel_id, task_id, part) {
                if (!this.plannedstate[user_id]) {
                    Vue.set(this.plannedstate, user_id, {});
                }

                let fdwp = formatteddate + '-' + part;

                if (!this.plannedstate[user_id][fdwp]) {
                    this.plannedstateSet("planned", taskmodel_id, user_id, formatteddate, part)
                        .then(() => {
                            this.decreaseAvailability(user_id, formatteddate);
                            this.decreaseBudget(task_id);
                        })
                } else {
                    // If we're handling a holiday type, stop execution
                    if (this.plannedstate[user_id][fdwp].type === "holiday" || this.plannedstate[user_id][fdwp].type === 'not-available') {
                        return;
                    }
                    // The record exists. Check what it is.
                    if (this.plannedstate[user_id][fdwp].type === "planned" && this.plannedstate[user_id][fdwp].uuid === taskmodel_id) {
                        this.plannedstateSet("open", taskmodel_id, user_id, formatteddate, part)
                            .then(() => {
                                this.increaseAvailability(user_id, formatteddate);
                                this.increaseBudget(task_id);
                            });
                    } else {
                        // Set it to planned
                        this.plannedstateSet("planned", taskmodel_id, user_id, formatteddate, part)
                            .then(() => {
                                this.decreaseAvailability(user_id, formatteddate);
                                this.decreaseBudget(task_id);
                            });
                    }
                }
            },

            increaseBudget(task_id) {
                let tmp = task_id.split('---');

                if (tmp.length === 3) {
                    task_id = tmp[0] + '---' + tmp[1];
                }
                let task = gantt.getTask(task_id);
                let parent = gantt.getTask(task.parent);
                let rate = this.halfDays === true ?
                    Math.ceil(parseInt(task.dailyrate) / 2) :
                    parseInt(task.dailyrate);

                parent.budget = parseInt(parent.budget) + rate;
                gantt.updateTask(parent.id);
            },

            decreaseBudget(task_id) {
                let tmp = task_id.split('---');

                if (tmp.length === 3) {
                    task_id = tmp[0] + '---' + tmp[1];
                }

                let task = gantt.getTask(task_id);
                let parent = gantt.getTask(task.parent);
                let rate = (this.halfDays === true ?
                    Math.ceil(parseInt(task.dailyrate) / 2) :
                    parseInt(task.dailyrate));

                parent.budget = parseInt(parent.budget) - rate;
                gantt.updateTask(parent.id);
            },

            plannedstateSet(newstate, taskmodel_id, user_id, date, part) {
                return new Promise((resolve, reject) => {
                    axios.post(this.getRoutes.planning.append,{
                        newstate, taskmodel_id, user_id, date, part,
                        project: this.project,
                    })
                    .then(() => {
                        Vue.set(this.plannedstate[user_id],date + '-' + part,{
                            "type": newstate,
                            "uuid": taskmodel_id,
                        });
                        gantt.refreshData();
                        resolve();
                    })
                    .catch(error => {
                        if (error.response && error.response.data.code === 101) {
                            this.$snotify.error('Deze medewerker heeft geen actief contract op deze datum en kan dus niet ingepland worden!');
                        } else if (error.response && error.response.data.code === 102) {
                            this.$snotify.error('Er kan niet buiten de looptijd van de taak gepland worden');
                        } else {
                            this.$snotify.error('Er is een fout opgetreden bij het opslaan van de planning');
                        }
                        reject();
                    });
                });
            },

            addWeek(){
                this.weeknr = moment(this.weeknr).add(1, 'w');
            },
            subWeek() {
                this.weeknr = moment(this.weeknr).subtract(1, 'w');
            },

            toggleHighlighting(user_id) {
                // Loop all tasks
                gantt.eachTask((task) => {
                    // Check if user id matches
                    if (task.id.split("---")[1] !== user_id) {
                        return;
                    }
                    // Check highlighting
                    if (task.highlight) {
                        task.highlight = false;
                    } else {
                        task.highlight = !task.highlight;
                    }
                    gantt.updateTask(task.id);
                })
            },

            closeOfficeSearch() {
                this.addfortask = '';
                $('#searchOfficeModal').modal('hide');
            },

            updateAvailability(user_id, date, increase = true) {
                // Check if the user exists
                if (!this.availability[user_id]) {
                    let obj = {
                        total:0,
                        weeks:{},
                    };
                    let date = moment(this.range[0]);
                    while (date.unix() < moment(this.range[1]).unix()) {
                        // Add it to the obj
                        obj.weeks[date.format("ww")] = 0;
                        // Add a week
                        date = date.add(1, "w");
                    }
                    Vue.set(this.availability, user_id, obj);

                }
                // Get weeknr
                let weeknr = moment(date).format('ww');
                // Get the availability
                let availability = this.availability[user_id];
                // Update total
                availability.total = increase ? availability.total + 1 : availability.total - 1;
                // Update week
                availability.weeks[weeknr] = increase ? availability.weeks[weeknr] + 1 : availability.weeks[weeknr] - 1;
                // Update total
                Vue.set(this.availability, user_id, availability);
            },

            decreaseAvailability(user_id, date) {
                // Update availability
                this.updateAvailability(user_id, date, false);
            },

            increaseAvailability(user_id, date) {
                // Update availability
                this.updateAvailability(user_id, date);
            },

            ganttTaskExists(id) {
                // Set exists boolean
                let exists = false;
                // Iterate over all tasks
                gantt.eachTask((task) => {
                    // Check if task.id matches the given id
                    if (task.id === id) {
                        exists = true;
                        return;
                    }
                });
                return exists;
            },

            openOfficeSearch() {
                $('#searchOfficeModal').modal('show');
            },

            onOfficeUserSelect(user) {
                // Get the task based on the stored id
                let task = gantt.getTask(this.addfortask);
                // Set the id
                let newid = task.id + "---" + user.uuid;
                // Check if the record already exists
                if (this.ganttTaskExists(newid)) {
                    return;
                }
                // Create a task object
                let newtask = {
                    id:newid,
                    parent:task.id,
                    text:user.fullname,
                    is_project:false,
                    is_task:false,
                    is_user:true,
                    project_uuid:task.project_uuid,
                    open:true,
                    start_date:task.start_date,
                    end_date:task.end_date,
                    dailyrate: user.dailyrate,
                };
                // Add the task to the gantt object
                gantt.addTask(newtask, newtask.parent);
                // Refresh gantt data
                gantt.refreshData();
                // Close the selection overlay
                this.closeOfficeSearch();
            },

            expandGantt(){
                gantt.expand();
            },

            exportToPdf() {
                name = 'planning-' + moment().format('YYYY-MM-DD-HH-mm') + '.pdf';
                gantt.exportToPDF({'name': name});
            },

            getAvailability(user_id) {
                if (!this.availability[user_id] || !this.availability[user_id].weeks || !this.availability[user_id].weeks[this.currentWeekNr]) {
                    return 0;
                }
                return this.availability[user_id].weeks[this.currentWeekNr];
            },

            getPlanning() {
                // Make the call
                axios.get(this.planningUri).then((response) => {
                    this.range = response.data.data.range;
                    this.weeknr = moment(this.range[0]).add(1,"week");
                    this.tasks.data = response.data.data.tasks;
                    this.availability = response.data.data.availability;
                    this.plannedstate = response.data.data.plannedstate;
                    this.plannedUsers = response.data.data.plannedUsers;
                    this.specialProjectUuid = response.data.data.specialProjectUuid;
                    this.loaded = true;
                });
            },

            getTeamData() {
                axios.get(this.teamsInfoUri).then((response) => {
                    this.teams.selectData = response.data.select;
                    this.teams.planningData = response.data.planning;
                    this.teams.loaded = true;
                });
            },

            onPlannedItemClick(task_id, date, withshift) {
                // Explode the
                let exploded = task_id.split("---");
                // Get the ids from the exploded array
                let taskmodel_id = exploded[0];
                let user_id = exploded[1];
                let part = exploded[2];
                // Set a formatted date
                let formatteddate = date.format("YYYY-MM-DD");

                // Check shiftkey
                if (true === withshift && this.lastaction.user_id === user_id && this.lastaction.taskmodel_id === taskmodel_id) {
                    // Set begin
                    let begin = moment(this.lastaction.date),
                        end = moment(date);

                    if (parseInt(this.lastaction.part) === 1 && this.halfDays === true) {
                        this.addPlannedState(user_id, begin.format('YYYY-MM-DD'), taskmodel_id, task_id, 2);
                    }
                    // Loop the dates
                    for (let m = moment(begin).add(1, "days"); m.isBefore(end); m.add(1, "days")) {
                        // Make sure m is not during the weekend
                        if (m.isoWeekday() !== 6 && m.isoWeekday() !== 7) {
                            this.addPlannedState(user_id, m.format("YYYY-MM-DD"), taskmodel_id, task_id, 1);
                            if (this.halfDays === true) {
                                this.addPlannedState(user_id, m.format("YYYY-MM-DD"), taskmodel_id, task_id, 2);
                            }
                        }
                    }
                } else {
                    this.addPlannedState(user_id, formatteddate, taskmodel_id, task_id, part);
                }
                // Store last action
                this.lastaction.taskmodel_id = taskmodel_id;
                this.lastaction.user_id = user_id;
                this.lastaction.date = formatteddate;
                this.lastaction.part = part;
            },

            addUser(task_id) {
                // Get the task
                let task = gantt.getTask(task_id);
                // Make sure a task is selected
                if (!task.is_task) {
                    return;
                }

                this.tasks.usersAlreadyAssigned = [];
                gantt.getChildren(task_id).forEach((id) => {
                    this.tasks.usersAlreadyAssigned.push(id.split('---')[1]);
                });

                // Store for which task.
                this.addfortask = task.id;
                // Open the modal
                this.openOfficeSearch();
            },

            removeUser(task_id) {
                // Get the task
                let task = gantt.getTask(task_id);
                // Make sure its a user
                if (!task.is_user) {
                    return;
                }
                // Store the user
                this.detachuser = task_id;
                // Fire event to show the remove confirmation modal
                Hub.$emit('show-remove-confirmation-modal','Gebruiker verwijderen uit planning','Weet je zeker dat deze gebruiker uit de planning verwijderd moet worden?','perform-detach-user-action');
            },

            performDetachUser() {
                // Make sure we are actually set to delete before we do anything
                if (this.detachuser === null) {
                    return;
                }
                // Store task_id
                let task_id = this.detachuser;
                let splitted = task_id.split("---");
                // Reset detachuser
                this.detachuser = null;
                // Remove the user from the task
                axios.patch(this.getRoutes.planning.detach, {
                    task_uuid: splitted[0],
                    user_uuid: splitted[1],
                    project: this.project,
                });
                // Update gantt
                gantt.deleteTask(task_id);
            },
            /*
             |
             | This method is basically a base JS method that checks which target element has been clicked on,
             | dispatching the proper method as a result. Be careful what you change here.
             |
             */
            onTaskClick(task_id, obj) {
                if (!obj.target || obj.target.classList.length === 0) {
                    // Simply return false;
                    return false;
                }
                // Store classlist
                let classList = obj.target.classList;
                // Set actions
                // Deletion
                if (classList.contains("fa-times")) {
                    this.removeUser(task_id);
                }
                // Creation
                if (classList.contains("fa-plus")) {
                    this.addUser(task_id);
                }
            },

            getFilteredOfficeUsers() {
                if (this.teams.selected.value === null) {
                    return this.getOfficeUsers;
                }
                return this.getOfficeUsers.filter(usr => Object.values(this.teams.selected.userUuids).includes(usr.uuid));
            },

            updateTeamSelected() {
                if (this.teams.selected.value === null) {
                    this.teams.selected.projectUuids = null;
                    this.teams.selected.userIds = null;
                } else {
                    let ret = this.teams.planningData.find(data => data.team_id === this.teams.selected.value);
                    this.teams.selected.projectUuids = ret.project_uuids;
                    this.teams.selected.userUuids = ret.user_uuids;
                }
                // Trigger the onBeforeTaskDisplay event, which applies the filter to the gantt chart.
                gantt.render();
            },

            toggleCheckedUser(user) {
                if (this.checkedUsers.includes(user.uuid)) {
                    this.checkedUsers = this.checkedUsers.filter((uuid) => {
                        return uuid !== user.uuid;
                    });
                } else {
                    this.checkedUsers.push(user.uuid);
                }

                this.checkedUsersProjects = [];
                this.checkedUsers.forEach((user_uuid, projects) => {
                    if (this.plannedUsers.hasOwnProperty(user_uuid)) {
                        this.checkedUsersProjects = this.checkedUsersProjects.concat(this.plannedUsers[user_uuid]);
                    }
                });

                // Trigger the onBeforeTaskDisplay event, which applies the filter to the gantt chart.
                gantt.render();
            },

            toggleCheckedUserAll(event) {
                for (let i = 0; i < this.getOfficeUsers.length; i++) {
                    const user = this.getOfficeUsers[i];

                    if (event.target.checked) {
                        this.checkedUsers.push(user.uuid);
                    } else {
                        this.checkedUsers = this.checkedUsers.filter((uuid) => {
                            return uuid !== user.uuid;
                        });
                    }
                }

                this.checkedUsersProjects = [];
                this.checkedUsers.forEach((user_uuid, projects) => {
                    if (this.plannedUsers.hasOwnProperty(user_uuid)) {
                        this.checkedUsersProjects = this.checkedUsersProjects.concat(this.plannedUsers[user_uuid]);
                    }
                });

                // Trigger the onBeforeTaskDisplay event, which applies the filter to the gantt chart.
                gantt.render();
            },
        },

        mounted() {
            this.getTeamData();
            this.getPlanning();
            this.parseData();
            // Listen to specific event.
            this.$nextTick(function () {
                Hub.$on('perform-detach-user-action', this.performDetachUser);
            }.bind(this));
            // Prepare the task filter.
            gantt.attachEvent("onBeforeTaskDisplay", (id, task) => {
                if (this.teams.selected.value === null && this.checkedUsers.length === 0) {
                    return true;
                }

                if (this.teams.selected.value !== null) {
                    return Object.values(this.teams.selected.projectUuids).includes(task.project_uuid);
                }

                if (this.checkedUsers.length) {
                    return this.checkedUsersProjects.includes(task.project_uuid);
                }
            });
        },

        name: "ProjectsPlanning",

        props: {
            planningUri: {
                type:String,
                required:true,
            },
            teamsInfoUri: {
                type:String,
                required:true,
            },
            project: {
                type:String,
                default:"",
            },
            showBudget: { default:false },
            showButtons: { default:false },
        },

    }

</script>

<style lang="scss">

.table-officeusers {
    overflow-y: scroll;

    tbody tr:first-child td:first-child {
        display: inline-block;
        height: 40px;
    }
    table td {
        padding: 1px 8px !important;
    }
}

</style>
